module.exports = __webpack_public_path__ + "img/tdzoom.4b1ddbae.jpg";